import { Panel } from "@/components/KpiCard";
import { SmartTable } from "@/components/SmartTable";
import { money } from "@/lib/api";

const COLS = [["debit", "Retraits"], ["tps_r", "TPS payée"], ["tvq_r", "TVQ payée"], ["credit", "Dépôts"], ["tps_d", "TPS perçue"], ["tvq_d", "TVQ perçue"], ["nc", "TPS/TVQ non créditables"]];
const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

const Ligne = ({ nom, v, cls = "", testId, fixe, titre }) => (
  <tr className={`border-t border-slate-100 ${cls}`} data-st-fixe={fixe ? "" : undefined} data-testid={testId}>
    <td className="py-1.5 px-3">{nom}</td>
    <td className="py-1.5 px-2 text-right font-mono text-xs text-slate-500">{titre ? "" : v.nb || 0}</td>
    {COLS.map(([k]) => <td key={k} className={`py-1.5 px-2 text-right font-mono text-xs ${k === "debit" || ((k === "tps_r" || k === "tvq_r") && v[k]) ? "text-red-700" : k === "credit" ? "text-emerald-700" : ""}`}>{titre ? "" : v[k] ? (k === "debit" || k === "tps_r" || k === "tvq_r" ? `-${money(Math.abs(v[k]))}` : money(v[k])) : "—"}</td>)}
  </tr>
);

const BlocImmeuble = ({ b }) => [
  <Ligne key={`${b.nom}-t`} nom={b.nom} v={{}} titre fixe cls="bg-emerald-50/60 font-semibold" testId={`resume-imm-${slug(b.nom)}`} />,
  ...b.rubriques.map((r) => <Ligne key={`${b.nom}-${r.nom}`} nom={<span className="pl-5 text-slate-600">{r.nom}</span>} v={r} fixe testId={`resume-rub-${slug(b.nom)}-${slug(r.nom)}`} />),
  <Ligne key={`${b.nom}-st`} nom={`Sous-total — ${b.nom}`} v={b.sous_total} fixe cls="bg-slate-50 font-semibold" testId={`resume-st-${slug(b.nom)}`} />,
];

const Tableau = ({ col1, children, total, testId }) => (
  <div className="overflow-x-auto -mx-5">
    <SmartTable id={testId} className="w-full text-sm min-w-[900px]" data-testid={testId}>
      <thead><tr className="bg-slate-900 text-white">
        <th className="py-2 px-3 text-left text-[11px] font-mono uppercase tracking-wider">{col1}</th>
        <th className="py-2 px-2 text-right text-[11px] font-mono uppercase">Nb</th>
        {COLS.map(([k, l]) => <th key={k} className="py-2 px-2 text-right text-[11px] font-mono uppercase tracking-wider">{l}</th>)}
      </tr></thead>
      <tbody>
        {children}
        <Ligne nom="Total" v={total} cls="bg-slate-100 font-semibold" testId={`${testId}-total`} fixe />
      </tbody>
    </SmartTable>
  </div>
);

export const ResumeCommentaires = ({ resume }) => (
  <div className="mt-6 space-y-6" data-testid="resume-commentaires">
    <Panel title="Résumé par catégorie de dépenses" testId="resume-categories-panel">
      <Tableau col1="Catégorie" total={resume.total} testId="resume-categories">
        {resume.categories.map((c) => <Ligne key={c.nom} nom={c.nom} v={c} testId={`resume-cat-${slug(c.nom)}`} />)}
      </Tableau>
    </Panel>
    <Panel title="Résumé par immeuble" testId="resume-immeubles-panel">
      <Tableau col1="Immeuble / rubrique" total={resume.total} testId="resume-immeubles">
        {[...resume.immeubles, resume.autres].map((b) => <BlocImmeuble key={b.nom} b={b} />)}
      </Tableau>
      <p className="text-xs text-slate-500 mt-3">Revenus loyer : tous les dépôts rattachés à l'immeuble · b à f : selon la catégorie de l'opération (Énergie compte dans Hydro) · Autres dépenses : opérations sans immeuble ou communes (catégorie « Dépenses de la compagnie » → Immobilière Assalem) · TPS/TVQ payées : incluses dans les retraits · perçues : incluses dans les dépôts.</p>
    </Panel>
  </div>
);
